// services/socketService.js - OPTIMASI
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
    this.pendingSubscriptions = new Set();
    this.debounceTimers = new Map();
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 10;
  }

  init() {
    if (this.socket?.connected) return;
    this.connect();
  }

  connect() {
    if (this.socket?.connected) return;

    this.socket = io(SOCKET_URL, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: this.maxReconnectAttempts,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Connected');
      this.reconnectAttempts = 0;
      const token = localStorage.getItem('token');
      if (token) {
        this.emit('authenticate', { token });
      }
      this.emitConnectionStatus(true);
      
      // Resubscribe ke vessel yang sebelumnya
      this.pendingSubscriptions.forEach(vesselId => {
        this.socket.emit('subscribe_vessel', vesselId);
      });
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Disconnected:', reason);
      this.emitConnectionStatus(false);
    });

    this.socket.on('connect_error', (error) => {
      console.error('[Socket] Connection error:', error);
      this.reconnectAttempts++;
      this.emitConnectionStatus(false);
    });
  }

  emitConnectionStatus(status) {
    const callbacks = this.listeners.get('connection_status');
    if (callbacks) {
      callbacks.forEach(cb => cb(status));
    }
  }

  disconnect() {
    if (this.socket) {
      this.pendingSubscriptions.clear();
      this.socket.disconnect();
      this.socket = null;
    }
  }

  emit(event, data) {
    if (this.socket?.connected) {
      this.socket.emit(event, data);
    }
  }

  subscribeVessel(vesselId) {
    if (!vesselId) return;
    this.pendingSubscriptions.add(vesselId);
    
    if (this.socket?.connected) {
      // Debounce multiple subscriptions
      if (this.debounceTimers.has('subscribe')) {
        clearTimeout(this.debounceTimers.get('subscribe'));
      }
      
      this.debounceTimers.set('subscribe', setTimeout(() => {
        this.socket.emit('subscribe_vessel', vesselId);
        this.debounceTimers.delete('subscribe');
      }, 100));
    }
  }

  unsubscribeVessel(vesselId) {
    this.pendingSubscriptions.delete(vesselId);
    
    if (this.socket?.connected) {
      this.socket.emit('unsubscribe_vessel', vesselId);
    }
  }

  on(event, callback) {
    if (!this.socket) {
      if (!this.listeners.has(event)) {
        this.listeners.set(event, []);
      }
      this.listeners.get(event).push(callback);
      return;
    }
    this.socket.on(event, callback);
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (!this.socket) return;
    if (callback) {
      this.socket.off(event, callback);
      const callbacks = this.listeners.get(event);
      if (callbacks) {
        const index = callbacks.indexOf(callback);
        if (index > -1) callbacks.splice(index, 1);
      }
    } else {
      this.socket.off(event);
      this.listeners.delete(event);
    }
  }

  isConnected() {
    return this.socket?.connected || false;
  }
}

const socketService = new SocketService();
export default socketService;